import React from 'react'
import { useRoutes } from 'hookrouter'
import { useSetLanguage } from 'store/locale/hooks/useSetLanguage'
import { Loader } from './ui/Behaviors/Loader'
import { localizedRoutes } from './routes'

interface ILocalizedAppProps {
  language: string
}

const LocalizedApp = ({ language }: ILocalizedAppProps) => {
  const hasLanguage = useSetLanguage(language)
  const component = useRoutes(localizedRoutes)

  return hasLanguage ? component : <Loader />
}

export default LocalizedApp
